// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getFactoryDayStatus, getShippingDayStatus } from '../atp-calendar/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import Calendar from '../common/components/calendar';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate, formatLocalDate } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AtpCalendarList extends Component {

    state = {
        result: [],
        type: 'factory',
        location: ''
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryType = query.get( 'type' );
        const queryLocation = query.get( 'location' );

        const date = new Date();
        const startDay = new Date( date.getFullYear(), date.getMonth(), 1 );
        const endDay = new Date( new Date( date.setMonth( date.getMonth() + 13 ) ).setDate( 0 ) );

        if ( queryType === 'shipping' ) {

            this.setState( {
                type: 'shipping',
                location: queryLocation
            } );

            getShippingDayStatus( formatLocalDate( startDay, 'YYYY-MM-DD' ), formatLocalDate( endDay, 'YYYY-MM-DD' ), queryLocation ).then( response => {

                this.setState( {
                    result: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else {

            this.props.increaseCounter();
            getFactoryDayStatus( formatLocalDate( startDay, 'YYYY-MM-DD' ), formatLocalDate( endDay, 'YYYY-MM-DD' ) ).then( response => {

                this.setState( {
                    result: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }
        window.scrollTo( 0, 0 );

    }

    getMonthYearList = () => {

        const list = [];
        const date = new Date();
        const startDay = new Date( date.getFullYear(), date.getMonth(), 1 );

        [...Array( 13 )].forEach( () => {

            list.push( { year: startDay.getFullYear(), month: startDay.getMonth() } );
            startDay.setMonth( startDay.getMonth() + 1 );

        } );
        return list;

    }

    processResult = result => {

        const res = [...result];
        res.sort( ( a, b ) => a.date - b.date );
        const mthYear = [];
        res.forEach( day => {

            const noshippingdate = formatGivenDate( day.date, 'YYYY-MM-DDTHH:mm:SS' );
            const year = new Date( noshippingdate ).getFullYear();
            const mth = new Date( noshippingdate ).getMonth();
            const date = new Date( noshippingdate ).getDate();

            if ( !mthYear[year] ) mthYear[year] = [];
            if ( !mthYear[year][mth] ) mthYear[year][mth] = [];
            mthYear[year][mth][date] = day;
            mthYear[year][mth][date].year = year;
            mthYear[year][mth][date].mth = mth;

        } );
        return mthYear;

    }

    showDetail = ( month, year ) => {

        const { pathname } = this.props.history.location;
        const calLink = `/${pathname.split( '/' )[1]}/parameters/atp-calendar/calendar-detail?type=${this.state.type}&month=${month}&year=${year}`;
        this.props.history.push( this.state.type === 'factory' ? calLink : `${calLink}&location=${this.state.location}` );

    }

    render () {

        const {
            type, result, location
        } = this.state;

        const fullRes = result.length > 0 ? this.processResult( [...result] ) : [];
        const heading = type === 'shipping' ? 'Shipping Calendar' : 'Factory Calendar';

        const mthYear = this.getMonthYearList();

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">{heading}</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="blurb-section">
                            <span className="back-link" onClick={() => this.props.history.push( `/${this.props.unit.name}/parameters/atp-calendar` )}> <i className="fa fa-angle-double-left" /> Back to ATP Calendar</span>
                        </div>
                        <div className="atp-calendar-index">
                            <table className="day-index">
                                <tbody>
                                    <tr>
                                        <td className="index-color production-day" />
                                        <td>{type === 'factory' ? 'Production Day' : 'Shipping Day'}</td>
                                    </tr>
                                    {type === 'factory' && (
                                        <tr>
                                            <td className="index-color holiday-day" />
                                            <td>Shutdown - Holiday</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="index-color shutdown-day" />
                                        <td>{type === 'factory' ? 'Shutdown - Factory' : 'No Shipping'}</td>
                                    </tr>
                                </tbody>
                            </table>
                            { type === 'shipping' && <div className="location-info">Inventory Location: {location}</div>}
                        </div>
                        <div className="atp-calendar-list">
                            {mthYear.map( ( mth, mthIndex ) => {

                                const data = fullRes[mth.year] &&
                                fullRes[mth.year][mth.month] ? fullRes[mth.year][mth.month] : [];
                                return (
                                    <Calendar
                                        key={`calendar-${mth.year}-${mth.month}-${mthIndex}`}
                                        month={mth.month}
                                        year={mth.year}
                                        data={data}
                                        detail={false}
                                        showDetail={this.showDetail.bind( this )}
                                    />
                                );

                            } )}
                        </div>
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

AtpCalendarList.displayName = 'AtpCalendarList';
AtpCalendarList.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( AtpCalendarList ) );
